//chapter1
export default {
    id : 8,//chapter number
    title : '08. DFMEA 작성방법 (1) - DFMEA의 준비',//chapter name
    slides : [
        {
            title : 'Intro',
            type : 'intro',
            source : 'c08.mp4',
        },
        {
            title : 'Today’s Goal',
            type : 'plan',
            body1 : [
                'DFMEA의 준비',
            ],
            body2 : [
                'DFMEA의 준비에 대해 설명할 수 있다.'
            ],
            bgm : "plan.mp3"
        },
        {
            title : 'Lesson',
            type : 'lesson',
            source : '08.mp4',
        },
        {
            title : 'Quiz',
            type : 'quiz',
            quiz : [
                {
                    type : 'ox',
                    question : '설계 FMEA를 위해 설계의도가 파악되어야 한다.',//html available
                    answer : "1",
                    explain : '설계 FMEA의 출발요소이다.'
                },
                {
                    type : 'ox',
                    question : '설계 FMEA는 공정의 요구와 관계가 없다.',//html available
                    answer : "2",
                    explain : '공정의 한계문제에 대한 검토가 있어야 한다.'
                },
            ],
            quizMask : "../assets/images/quiz_intro.jpg",//quiz mask
            bgm : "quiz.mp3"
        },
        {
            title : 'Summary',
            type : 'summary',
            /*download : 'sample.pptx',//data folder*/
            print : false,// true : show, false: hide
            slides : [
                {
                    body : `<ul>
                        <h3>1. DFMEA 개요</h3>
                        <li>DFMEA 목적, 실행시기, 적용조건</li>
                        <p class="mg10"></p>
                        <h3>2. DFMEA 준비사항</h3>
                        <li>설계의도 파악</li>
                        <li>분석수준(LEVEL) 결정</li>
                        <li>고객 정의</li>
                        <li>팀 노력</li>
                    </ul>`
                },
                {
                    body : `<ul>
                        <h3>2. DFMEA 준비사항</h3>
                        <li>LIVING DOCUMENT</li>
                        <li>제조/조립의 요구 반영</li>
                        <li>제조/조립 공정의 검토사항</li>
                        <p class="mg10"></p>
                        <h3>3. STEP 1 : 범위 정의 및 프로젝트 기획</h3>
                        <li>ITEM 설정</li>
                        <li>검토항목</li>
                        <li>프로젝트 정의와 범위</li>
                    </ul>`
                },
            ],
            bgm : "summary.mp3"
        },
        {
            title : 'Outro',
            type : 'outro',
            source : 'c08.mp4',
        },
    ]
}